function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}
export {
  isVariantLabel
};
